import { RESET_LOYALTY_ACCOUNT } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'

/** Forgets the loyalty account state, so the next read starts afresh. */
function resetLoyaltyAccount(): AppAction {
  return {
    type: RESET_LOYALTY_ACCOUNT,
  }
}

export default resetLoyaltyAccount
